import React, { useState, useRef, useEffect, MouseEvent, TouchEvent } from "react";
import styled from "styled-components";
import Tooltip from "../../../ui/components/Tooltip";
import Button from "../../../ui/components/Button";
import MenuOpen from "../../../ui/components/MenuOpen";
import { useGameList } from "../../../backend/useGameList";
import { useGameArt } from '../../../backend/useGameArt';
import { useUser } from '../../../backend/useUser';

const GameContainer = styled.div`
`;

interface GameArtMenuProps {
    config: any;
    aiImage: string;
    artId: string;
    artName: string;
    history: any[];
    currentIndex: number;
}

const GameArtMenu = ({ config, aiImage, artId, artName, history, currentIndex }: GameArtMenuProps) => {
    const { user, loading: userLoading } = useUser();
    const [gameMenuAnchorEl, setGameMenuAnchorEl] = useState<HTMLElement | null>(null);
    const [gameList, setGameList] = useState<any[]>([]);
    const { listMyGames } = useGameList();
    const { associateGameArt } = useGameArt();
    const gameDivRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!userLoading && user) {
            getGames();
        }
    }, [user, userLoading]);

    const getGames = async () => {
        try {
            const { games, hasMore: more } = await listMyGames(user.id, 1, 20);
            // console.log('games list: ', games);
            setGameList(games);
        } catch (error) {
            console.error('Error listing games:', error);
        }
    };

    const handleGameMenuClick = (event: MouseEvent<HTMLButtonElement> | TouchEvent<HTMLButtonElement>) => {
        if (gameMenuAnchorEl) {
            setGameMenuAnchorEl(null);
        } else {
            setGameMenuAnchorEl(gameDivRef.current);
        }
    };

    const handleGameMenuClose = () => {
        setGameMenuAnchorEl(null);
    };

    const handleGameSelect = (game) => {
        // console.log('Adding image to game: ', game.game_name, game.id); 
        addImageToGame(game.id);
        handleGameMenuClose();
    };

    const addImageToGame = async (gameId) => {
        // console.log('Adding art to game:', gameId, 'for art id:', artId);
        
        try {
            // Check if we have a valid AI image to add
            if (!aiImage) {
                console.error('No AI image available to add to game');
                return;
            }
            
            // Create a game art entry using the useGameArt hook
            const gameArt = await associateGameArt(
                gameId,
                artName,
                aiImage,
                'ai_generated',
                artId
            );
            
            // console.log('Successfully added art to game:', gameArt);
        } catch (error) {
            console.error('Error adding art to game:', error);
        }
    };

    return (
        config.ENABLE_GAME_ART_PANEL_MENU && (
            <>
                <GameContainer ref={gameDivRef}>
                    <Tooltip text="Add to Game" colorMode="dark" hide={Boolean(gameMenuAnchorEl)}>
                        <Button 
                            size={'small'} 
                            icon={'export'} 
                            color={'ghost'} 
                            onClick={handleGameMenuClick}
                            disabled={history[currentIndex]?.aiImage === ''}
                        />
                    </Tooltip>
                </GameContainer>
                <MenuOpen
                    anchorEl={gameMenuAnchorEl}
                    open={Boolean(gameMenuAnchorEl)}
                    onClose={handleGameMenuClose}
                    options={gameList.length > 0 
                        ? gameList.map(game => ({ 
                            text: game.game_name, 
                            onClick: () => handleGameSelect(game) 
                        }))
                        : [{ text: "No games available", disabled: true }]
                    }
                />
            </>
        )
    );
};

export default GameArtMenu;